import { Create, getValueFromEvent, useFileUploadState, useForm } from "@refinedev/antd";
import { InboxOutlined, WarningOutlined } from "@ant-design/icons";
import { Form, message, Tag, Upload, Space } from "antd";
import { IResourceComponentsProps, useApiUrl, useNotification } from "@refinedev/core";
import { INavWarnings } from "interfaces";
import { FormSection } from "components/form";
import React, { useState } from "react";

export const NavWarningsCreate: React.FC<IResourceComponentsProps> = () => {
  const [fileList, setFileList] = useState([]);
  const { onChange, isLoading: isFileUploading } = useFileUploadState();
  const { open, close } = useNotification();
  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<INavWarnings>({
    redirect: "list",
    resource: "nav-warnings",
    successNotification: (data, values, resource) => {
      return {
        message: `uploaded navigational warnings`,
        description: "Success",
        type: "success",
      };
    },
    errorNotification: (data, values, resource) => {
      return {
        message: `failed to upload navigational warnings`,
        description: "Error",
        type: "error",
      };
    },
  });
  const apiUrl = useApiUrl();

  const handleChange = (info: any) => {
    let newFileList = [...info.fileList];
    setFileList(newFileList as any);
    onChange(info);
  };

  const props = {
    name: "files",
    multiple: true,
    maxCount: 50,
    action: `${apiUrl}/upload/multiple`,
    onChange: handleChange,
  };

  const handleSubmit = async (values: any) => {
    const { files: fileList } = values;
    const formData = new FormData();
    fileList.forEach((file: any) => {
      formData.append("files", file.originFileObj);
    });

    try {
      const response = await fetch(`${apiUrl}/upload/multiple`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        message.error(`File upload failed`);
      }

      const data = await response.json();
      message.success("Files uploaded successfully");
    } catch (error) {
      message.error("File upload failed");
    }
  };

  return (
    <Create
      breadcrumb={false}
      resource="nav-warnings"
      saveButtonProps={{ ...saveButtonProps }}
      headerProps={{
        onBack: () => window.history.back(),
        title: "Digital Bookshelf",
        subTitle: "worldwide navigational warnings",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form
        {...formProps}
        layout="vertical"
      >
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="File Upload"
            subtitle="Upload navigational warning files (multiple files supported)"
            icon={<WarningOutlined />}
            variant="elevated"
          >
            <Form.Item
              name="files"
              label="Upload Files"
              valuePropName="fileList"
              getValueFromEvent={getValueFromEvent}
              noStyle
            >
              <Upload.Dragger
                {...props}
                listType="picture"
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag files to this area to upload
                </p>
                <p className="ant-upload-hint">Support for multiple file upload.</p>
              </Upload.Dragger>
            </Form.Item>
          </FormSection>
        </Space>
      </Form>
    </Create>
  );
};
